import { useManualOccurrence } from "contexts/register/ManualOccurrence";
import { useMemo } from "react";
import * as S from "./styles";

export default function HistoryTab() {
  const { occurrenceToEdit } = useManualOccurrence();

  const sortedHistoryItems = useMemo(() => {
    return occurrenceToEdit.history.sort(
      (a, b) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    );
  }, [occurrenceToEdit]);

  function formatDate(dateString: string) {
    const date = new Date(dateString);

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    return `${day}-${month}-${year} - ${hours}:${minutes}:${seconds}`;
  }

  if (occurrenceToEdit.history.length === 0) {
    return (
      <S.NoDataContainer>
        <h1>Essa ocorrencia ainda não possui um historico de ações</h1>
      </S.NoDataContainer>
    );
  }

  return (
    <S.Wrapper>
      <header>
        <h1>Historico de ações da ocorrencia</h1>
      </header>

      <S.HistoryContent>
        {sortedHistoryItems.map((historyItem) => (
          <S.HistoryItem data-cy={historyItem.id}>
            <S.DateContainer>
              <p>{formatDate(historyItem.createdAt)}</p>
            </S.DateContainer>

            <S.ActionContainer>
              <p>Ação</p>
              <p>{historyItem.actionType}</p>
            </S.ActionContainer>

            <S.AttendantContainer>
              <p>Responsavel</p>
              <p>{historyItem?.attendant?.name}</p>
            </S.AttendantContainer>
          </S.HistoryItem>
        ))}
      </S.HistoryContent>
    </S.Wrapper>
  );
}
